/*
 * @Date: 2023-04-20 20:52:53
 * @LastEditors: murray
 * @LastEditTime: 2023-05-15 19:55:59
 * @FilePath: \haizol-saas-console-supplier\src\mixins\permission-verification.js
 * @Description: 路由守卫，根据用户会员信息跳转到引导页，要做权限控制的页面直接mixins引入
 */

import { getSearchPermission } from '@/utils/api/permission-verification.js'
import { mapMutations } from 'vuex'
import store from '@/store'
export default {
  computed: {
  },
  async beforeRouteEnter(to, from, next) {
    const authentication = (value) => {
      switch (value) {
        case 1:
          next()
          break
        case 5:
          next()
          break
        default:
          next({
            path: '/boot-page',
            query: {
              to: to.name
            }
          })
          break
      }
    }
    let accessData = store.state.permissionVerification?.accessData
    // 判断当前身份, 跳转到对应的引导页
    if(accessData) {
      // 如果store里面已经存在, 直接拿来判断
      authentication(accessData?.accessPermission)
    } else {
      // 如果store里面不存在, 重新请求
      await store.dispatch('permissionVerification/requestAccessData')
      accessData = store.state.permissionVerification?.accessData
      authentication(accessData?.accessPermission)
    }
  },

}
